/**
 * 定义mutations方法
 */
import * as types from './mutation-types'
const mutations = {
  [types.WEBSOCKET_CONNECT] (state, webSocketConnect) {
    state.webSocketConnect = webSocketConnect
  },
  [types.WEBSOCKET_MSG] (state, webSocketMsg) {
    state.webSocketMsg = webSocketMsg
  },
  [types.ISLOGIN] (state, isLogin) {
    state.isLogin = isLogin
  },
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.STUDENT_DETAILSID] (state, row) {
    state.detailsID = row
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js